<template> 
    <div class="content-main">
        <div class="top-pass-main">
            <div class="passage-main">
                <div class="passage-intro">Hello internet,</div>
                <p class="passage-content">
                    Want to learn a new skill? <br>
                    Maybe get inspired...or perhaps pursue your dreams with code?<br>
                    With <b>CodeGill's</b> online-sessions, we make that possible! 
                </p>
                <img src="../../assets/code.gif" class="codegif">
            </div> 

            <img src="../../assets/mainpng.png" class="abstract-image">
        </div>
        
        <div class="scroller-main">
            <div class="scroller-one">
                <div id="title-cursor">
                    <div class="scroller-one-title"> Why CodeGill? </div>    
                    <img src="../../assets/cursor.gif"  id="cursor-blink">
                </div>
                
                
                <p class="scroller-one-content">
                    If you're passionate about building cool stuff, then you're in the right place. We provide a variety of online sessions designed to sharpen your coding skills and launch you into exciting new coding adventures. Explore fields you might just fall in love with and start building today!
                </p>
            </div>

            <div class="scroller-two">
                <div id="title-cursor">
                    <div class="scroller-two-title"> How does it work?</div>
                    <img src="../../assets/cursor.gif"  id="cursor-blink">
                </div>
                <p class="scroller-two-content">
                    CodeGill offers a dynamic and engaging learning environment. Our online sessions are designed for collaboration, providing a real-time educational experience that's both effective and enjoyable. Participants of all ages join their mentors in these interactive sessions, exploring the fun and exciting world of coding throughout the course. This approach is suitable for everyone, regardless of age, making coding accessible and enjoyable for all who are interested in learning.
                </p>
                <iframe src="https://www.youtube.com/embed/TQD-PlAgt-A" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="video">
                </iframe> 
                
                </div>
                
         </div>
         
         <div class="scroller-two">
                
         <Objectives/>
         </div>
         <div class="scroller-two">
         <div id="title-cursor">
                    <div class="scroller-two-title"> Our Courses</div>
                    <img src="../../assets/cursor.gif"  id="cursor-blink">
                </div>
        <CoursesCards/>
         </div>
         <div class="scroller-two">
             <div id="title-cursor">
                    <div class="scroller-two-title"> Our Community Server</div>
                    <img src="../../assets/cursor.gif"  id="cursor-blink">
                </div>
             <iframe src="https://discordapp.com/widget?id=714851124019986583&theme=dark" width="300" height="400" allowtransparency="true" frameborder="0" id="server"></iframe>
         </div>
            <div class="dj-shaders">
            </div>
    </div>
</template>


<script>
import CoursesCards from './CoursesCards'
import Objectives from './Objectives'
export default {
    name:'Content',
    components:{
        CoursesCards,
        Objectives

    }    
}
</script>

<style scoped>
     
    
    #cursor-blink{
        margin-left: 1rem;
        width: 1.5rem;
        height: 2rem;
    }

    #title-cursor{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        pointer-events: none;
    }
    #server{
        margin-top: 3rem;
    }
    .video{
        width: 40rem;
        height: 20rem;
        border: 2px solid #7f7fe4;
        border-radius:0.5rem ;
    }
    .content-main{
        margin-top: 3rem;
        width: 100%;
         -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10+ and Edge */
         user-select: none; /* Standard syntax */
        -webkit-user-drag: none;
    }
    .codegif{
        width: 35rem;
        margin: 0;
        pointer-events: none;
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10+ and Edge */
        user-select: none;
        -webkit-user-drag: none;
    }

    .abstract-image{
        width: 35rem;
        
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10+ and Edge */
         user-select: none; /* Standard syntax */
        -webkit-user-drag: none;
        pointer-events: none;
    }
    .dj-shaders{
        bottom: 0;
        width: 100%;
        position: fixed;
        height: 1rem;
        background-color: white;
        border-radius:5rem 5rem 0 0 ;
        box-shadow: 0 1rem 1rem 2rem rgb(255, 255, 255);
        
    }

    .top-pass-main{
        width: 100%;
        display: flex;
        flex-direction: row;
     
        align-items: center;
        justify-content: center;
        
    }

    .passage-main{
        width: 50%;
        font-family: 'Josefin Sans', sans-serif;
        margin:2rem;
    
    }
    
    .passage-intro{
        font-size: 4em;
        font-family: 'Chelsea Market', cursive;
        text-shadow: 0.2rem 0.2rem #7f7fe4;
    }

    .passage-content{
        font-size: 1.6em;
        line-height: 1.5;
        color: rgb(63, 63, 63);

    }
    .scroller-main{
        width: 100%;
    }

    .scroller-one{
        width: 100%;
        margin-top: 6rem;
        display: flex;
        text-align: center;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        
    }

    .scroller-one-title{
        font-family:'Chelsea Market', cursive;
        font-size: 2.5em;
        text-shadow: 0.1rem 0.1rem #7f7fe4;
    }

    .scroller-one-content{
        width: 70%;
       font-family:'Josefin Sans', sans-serif;
        font-size: 1.5em; 
        line-height: 1.5;
        color: rgb(63, 63, 63);
        text-align: left;
    }


    .scroller-two{
        width: 100%;
        margin-top: 4rem;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .scroller-two-title{
        font-family:'Chelsea Market', cursive;
        font-size: 2.5em;
        text-shadow: 0.1rem 0.1rem #7f7fe4;
    }

    .scroller-two-content{
        width: 70%;
       font-family:'Josefin Sans', sans-serif;
        font-size: 1.5em; 
        line-height: 1.5;
        color: rgb(63, 63, 63);
        text-align: left;
    }
    @media screen and (max-width:1024px){
    .abstract-image{
        width: 22rem;
        height: 22rem;
        
    
    }
    .codegif{
        width: 25rem;
    }
    .video{
        width: 30rem;
        height: 15rem;
        border: 1.5px solid #7f7fe4;
        border-radius:0.5rem ;
    }
    }


    @media screen and (max-width:768px){
       
        body{
            overflow-x: hidden;
            overflow-y: scroll;
        }
        #cursor-blink{
        margin-left: 0.5rem;
        width: 1rem;
        height: 1.3rem;
    }

    .video{
        width: 20rem;
        height: 12rem;
        border: 1px solid #7f7fe4;
    }
        .content-main{
        margin-top: 7rem;
        width: 100%;
         -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10+ and Edge */
         user-select: none; /* Standard syntax */
        -webkit-user-drag: none;
       
    }
    .codegif{
        width: 20rem;
        
        margin: 0; 
        
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10+ and Edge */
        user-select: none; /* Standard syntax */
        -webkit-user-drag: none;
    }
    .top-pass-main{
        width: 100%;
        display: flex;
        flex-direction: column-reverse;
     
        align-items: center;
        justify-content: center;
    }
    .abstract-image{
        width: 17rem;
        height: 17rem;

    }
    .passage-main{
        margin-top:1rem;
        font-family: 'Josefin Sans', sans-serif;
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    
    }

    .passage-intro{
        font-size: 2.5em;
    }

    .passage-content{
        width: 60%;
        font-size: 1.2em; 
        line-height: 1.5;
        text-align: center;

    }

    .scroller-one{
        width: 100%;
        margin-top: 1rem;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .scroller-one-title{

        font-size: 1.6em;
    }

    .scroller-one-content{
        width: 70%;
       font-family:'Josefin Sans', sans-serif;
        font-size: 1.2em; 
        line-height: 1.5;
    }


    .scroller-two{
        width: 100%;
        margin-top: 2rem;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .scroller-two-title{
        font-size: 1.6em;
    }

    .scroller-two-content{
        width: 70%;
       font-family:'Josefin Sans', sans-serif;
        font-size: 1.2em; 
        line-height: 1.5;
    }

    }
</style>